'use client'

import { useState } from 'react'
import { SelectBlockFragment } from './SelectBlock.generated'
import { SelectItemFragment } from './SelectItem.generated'
import { cn } from '@desoutter/uikit'
import Image from 'next/image'

type SelectBlockProps = {
	fragment: SelectBlockFragment
}

export default function SelectBlock({ fragment }: SelectBlockProps) {
	const [selectedItem, setSelectedItem] = useState<SelectItemFragment>(
		fragment.items[0],
	)

	const onSelect = (id: string) => {
		const item = fragment.items.find((item) => item.id === id)
		if (item) {
			setSelectedItem(item)
		}
	}

	return (
		<div
			id={fragment.anchor ? 'spy_' + fragment.anchor.replaceAll(' ', '_') : ''}
			className={fragment.isDark ? 'dark' : ''}
		>
			<div className="bg-background text-foreground">
				<div className="container-auto flex flex-col gap-4 py-24">
					<div className="flex flex-col gap-1">
						<h2 className="text-3xl">{fragment.title}</h2>
						<p className="text-xl">{fragment.subtitle}</p>
					</div>
					<div className="grid grid-cols-1 md:grid-cols-3 md:gap-4">
						<div className=" flex flex-col md:me-6">
							{fragment.items.map((item, index) => (
								<div
									key={item.id}
									className={cn(
										'p-4 border-b border-gray-200 flex items-center gap-4',
										selectedItem?.id === item.id &&
											'bg-gray-50 dark:bg-gray-800',
									)}
								>
									<div className="min-w-2 w-2 h-2 rounded-full bg-current" />
									<button
										className="flex items-center gap-4 text-lg text-start"
										onClick={() => onSelect(item.id)}
									>
										<p>{item.title}</p>
									</button>
								</div>
							))}
						</div>
						{selectedItem && (
							<div className="ms-0 mt-4 md:mt-0 md:ms-6 px-10 py-12 col-span-1 md:col-span-2 bg-gray-50 dark:bg-gray-800 rounded-lg">
								<div className="flex gap-4">
									{selectedItem.tags.map((tag) => (
										<div
											className="px-3 py-1 text-xs bg-gray-100 rounded-md text-gray-700 dark:bg-gray-700 dark:text-gray-200"
											key={tag.id}
										>
											{tag.name}
										</div>
									))}
								</div>
								{selectedItem.image && (
									<div className="mt-6 max-w-80">
										<Image
											src={selectedItem.image.url}
											alt={selectedItem.image.alt}
											width={selectedItem.image.width}
											height={selectedItem.image.height}
										/>
									</div>
								)}

								<div
									dangerouslySetInnerHTML={{ __html: selectedItem.content }}
									className="markdown mt-6"
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
